module.exports = __webpack_public_path__ + "img/Framed-Tiles.0dfe5a28.jpg";